<div class="compact-mode">
  <router-outlet></router-outlet>
<!--  <app-loader></app-loader>-->
</div>
